import { z, type ZodType } from 'zod';

export const jsonPrimitiveSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);

export type JsonPrimitive = z.infer<typeof jsonPrimitiveSchema>;

export type JsonValue =
  | JsonPrimitive
  | JsonValue[]
  | { [key: string]: JsonValue };

export const jsonValueSchema: ZodType<JsonValue> = z.lazy(() =>
  z.union([
    jsonPrimitiveSchema,
    z.array(jsonValueSchema),
    z.record(jsonValueSchema),
  ]),
);

/**
 * We strictly define the type of object that can be stored in literal values by the Json
 * standard.
 */
export const jsonObjectSchema = z.record(jsonValueSchema);
export type JsonObject = z.infer<typeof jsonObjectSchema>;
